<app-bread-crumb></app-bread-crumb>

<app-news-info [FunctionID]="this.yieldres.FunctionID"></app-news-info>

